exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".horizontalScroll{width:1040px;overflow-x:auto;white-space:nowrap}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./client/app/components/enquiry/enquiryEdit/enquiryVehicles/enquiryVehicles.styl
// module id = 1352
// module chunks = 0